module.exports = __webpack_public_path__ + "img/type1-1.0ecf5f0f.png";